<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>消息中心</el-breadcrumb-item>
      <el-breadcrumb-item>消息列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-button size="mini" @click="newMessage">新建消息</el-button>
    <el-table height="550px" :data="MsgList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          label="操作"
          align="center"
          width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="scope.row.isRead === 2" @click="readMsg(scope.row)">阅读</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="消息时间"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="isRead"
          label="消息状态"
          align="center"
          :formatter="stateFormatter"
          width="150">
        </el-table-column>
        <el-table-column
          prop="msgTypeName"
          label="消息模块"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="comment"
          label="消息内容"
          align="center">
        </el-table-column>
        
      </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      MsgList:[],
      orgId:'',
      stateText:[
        {isRead:1, name:'已读'},
        {isRead:2, name:'未读'},
      ],
      baseRequest:{
        orgId: '',
        pageNum:'',
        pageSize:'',
      },
      currentPage: 1,
      pageSize: 20,
      pageTotal: 0,
    }
  },
  methods:{
    newMessage(){
      this.$router.push("/new/message")
    },
    // async loadNotReadMsg(){
    //   const {data:res} = await this.$http.get(`/pengpengMsg/orgId/${this.orgId}` )
    //   this.MsgList = res.data;
    // },
    async loadAllMsg(){
      this.baseRequest.orgId = this.orgId;
      this.baseRequest.pageNum = this.currentPage;
      this.baseRequest.pageSize = this.pageSize;
      const {data:res} = await this.$http.post(`/pengpengMsg/all`, this.baseRequest )
      this.MsgList = res.data.list;
      this.pageTotal = res.data.total;
    },
    async readMsg(data){
      const {data:res} = await this.$http.put(`pengpengMsg/read/${data.id}`)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadAllMsg();
      window.location.reload();
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.isRead === item.isRead) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadAllMsg();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadAllMsg();
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.loadAllMsg();
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message.vue